import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export async function submitAndroidTester(
  email: string,
  checkboxAccepted: boolean
): Promise<void> {
  await addDoc(collection(db, 'androidTesters'), {
    email,
    submittedAt: serverTimestamp(),
    source: 'android-testers-page',
    checkboxAccepted,
  });
}
